/**
 * Libraries
 */

import type { RouteLocationRaw } from 'vue-router';

/**
 * Types
 */

import { routeTicketEnum } from '@core/router/routeNames';
import type { TicketNavigationGuardOutcome } from '@core/middleware/ticket';

function resolveTicketNavigationRedirect(
  result: TicketNavigationGuardOutcome,
): RouteLocationRaw {
  switch (result.status) {
    case 'redirect':
      return { ...result.location, replace: true };
    case 'route_denied':
    case 'forbidden':
      return { name: routeTicketEnum.DASHBOARD };
    case 'not_found':
      return {
        name: routeTicketEnum.NOT_FOUND,
        params: { all: '404' },
        replace: true,
      };
    case 'technical':
      return {
        name: routeTicketEnum.TECHNICAL_ERROR,
        query: { retry: result.retryFullPath },
        replace: true,
      };
    default:
      return { name: routeTicketEnum.DASHBOARD };
  }
}

export { resolveTicketNavigationRedirect };
